var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWidgets(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "184.61 -819.69 636.62 635.08",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M652.15-481.54 483.08-650.62l169.07-169.07 169.08 169.07-169.08 169.08Zm-467.54-53.84v-240.01h240.01v240.01H184.61Zm350.77 350.77v-240.01h240.01v240.01H535.38Zm-350.77 0v-240.01h240.01v240.01H184.61Zm40.01-390.77h160v-160h-160v160Zm428.53 38.76 113-113-113-113-113 113 113 113Zm-77.77 312h160v-160h-160v160Zm-350.76 0h160v-160h-160v160Zm160-350.76Zm155.53-74.24Zm-155.53 265Zm190.76 0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWidgets);
export default __webpack_public_path__ + "static/media/widgets.bd5331e2ac54906afe4053026284759e.svg";
export { ForwardRef as ReactComponent };